const DELIVERY_API = 'https://cdn.contentful.com';
const PREVIEW_API = 'https://preview.contentful.com';

// For quick testing using preview environment
const TEST_PREVIEW = false;
const PREVIEW_TOKEN = ''; // add preview token (from Keeper)

const buildContentfulUrl = ({
  spaceId,
  environment,
  entryId,
  token,
  locale,
}) => {
  let url = DELIVERY_API;

  if (TEST_PREVIEW) {
    url = PREVIEW_API;
    token = PREVIEW_TOKEN;
  }

  url = `${url}/spaces/${spaceId}/environments/${environment}/entries/${entryId}?locale=${locale}&access_token=${token}`;
  return url;
};

export default buildContentfulUrl;
